const PageTypes = Object.freeze({
  Static: 0, // 靜態頁面，初始化時沒有 API Request
  Dynamic: 1,
  DynamicWithBannerLayout: 2, // 頁面有 `.fui-banner`
});

export { PageTypes };
